import { createQuery } from '@amzn/gsce-shared-react-lib';
import {
  GetRiskScoreFilterOptionsCommand,
  type GetRiskScoreFilterOptionsCommandInput,
  type GetRiskScoreFilterOptionsCommandOutput,
} from '@amzn/gbsa-helios-typescript-client';

import { apiHeliosClient, withRetry } from 'src/v2/shared/data';
import { RiskScoreQueryKeys } from './keys';

/**
 * Selection-aware (faceted) filter options for the Risk Engine list. Each facet is counted with
 * the OTHER fields' selections applied but not its own, so the user can keep multi-selecting
 * within a field. Re-request whenever the selection changes to refresh the counts — the caller
 * debounces the selection so a burst of chip toggles collapses into one call.
 */
export const useGetRiskScoreFilterOptionsQuery = createQuery<
  GetRiskScoreFilterOptionsCommandInput,
  GetRiskScoreFilterOptionsCommandOutput
>(RiskScoreQueryKeys.filterOptions, (input) =>
  withRetry(() => apiHeliosClient.send(new GetRiskScoreFilterOptionsCommand(input))),
);
